<div class="sfl">
    <div class="sfl-search">
        <input class="w-100 form-control form-control-sm" (input)="searchInFields($event.target.value)">
        <i *ngIf="!searchStringFormatted || searchStringFormatted.length < 1" class="fad fa-search"></i>
        <i *ngIf="searchStringFormatted && searchStringFormatted.length > 0" (click)="searchStringFormatted = ''" class="fad fa-times text-danger"></i>
    </div>
    <div class="sfl-items" *ngIf="!loadingFields" (scroll)="scroll()">
        <ng-container *ngFor="let item of fields">
            <generic-sfl-item *ngIf="!item.isgroup || (item.isgroup && item.items.length > 0)" [prefix]="prefix" [item]="item" (updated)="scroll()" (isReady)="isReady.emit(true)"></generic-sfl-item>
        </ng-container>
    </div>
    <ng-container *ngIf="loadingFields">
        <div class="sfl-loader p-4 text-center">
            <i class="fad fa-spinner-third fa-spin"></i>
        </div>
    </ng-container>
</div>